import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragHandleIcon from './DragHandleIcon';
import tableStyles from './tableStyles';

interface Column {
  id: string;
  label: string;
}

interface SortableHeaderCellProps {
  column: Column;
}

const SortableHeaderCell: React.FC<SortableHeaderCellProps> = ({ column }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: column.id,
  });

  return (
    <th
      ref={setNodeRef}
      style={{
        ...tableStyles.th,
        transform: CSS.Transform.toString(transform),
        transition: transition || 'transform 200ms ease',
        opacity: isDragging ? 0.35 : 1,
        background: isDragging ? 'var(--hover-bg)' : undefined,
        position: 'relative',
        zIndex: isDragging ? 10 : 'auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
          {...attributes}
          {...listeners}
          style={tableStyles.handle}
          onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.background = 'var(--hover-bg)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.background = 'transparent')}
          title="Drag to reorder"
        >
          <DragHandleIcon />
        </span>
        {column.label}
      </div>
    </th>
  );
};

export default SortableHeaderCell;
